module.exports = __webpack_public_path__ + "media/images/front/pc/treatment-introduction-article/img02-0f8463cfbf3bdbf7745d4062c62d0271.png";